import { Component, Vue } from 'vue-property-decorator'
import CBAG1010ViewModel from './CBAG1010ViewModel'
import CBAG1010Service from './CBAG1010Service'

import ContentTab1 from './components/ContentTab1.vue'
import ContentTab2 from './components/ContentTab2.vue'
import { FormatConstants } from '@/common/FormatConstants'
import CommonUtil from '@/common/utils/CommonUtil'
import { fixedContentNoLogin } from '@/assets/js/main.js'

@Component({
  name: 'CBAG1010',
  components: {
  ContentTab1,
  ContentTab2
  }
  })
export default class CBAG1010Controller extends Vue {
  private cbag1010ViewModel: CBAG1010ViewModel = {
    notPrncpSecrTypLst: [
      {
        productName: '',
        operatCmpny: '',
        productDiv: '',
        operatMethod: '',
        feeTrustRewd: '',
        feeTrustPropertyReservesPric: null,
        descFilesUrl: '',
        operatRptUrl: '',
        trustRewdShhnFlg: ''
      }
    ],

    notPrncpSecrTypStpNewLst: [
      {
        productName: '',
        operatCmpny: '',
        productDiv: '',
        operatMethod: '',
        feeTrustRewd: '',
        feeTrustPropertyReservesPric: null,
        descFilesUrl: '',
        operatRptUrl: '',
        teishiriyuUrl: '',
        trustRewdShhnFlg: ''
      }
    ],

    prncpSecrTypLst: [
      {
        productName: '',
        operatCmpny: '',
        productDiv: '',
        midCancelDeductExist: null,
        descFilesUrl: '',
        investPerformUrl: ''
      }
    ],

    prncpSecrTypStpNewLst: [
      {
        productNameFormalName: '',
        operatCmpny: '',
        productDiv: '',
        midCancelDeductExist: null,
        descFilesUrl: '',
        investPerformUrl: '',
        teishiriyuUrl: ''
      }
    ],

    tabActive: 1,
    batchDispDiv: ''
  }

  /**
   * サービス対象を初期化する。
   */
  private cbag1010Service: CBAG1010Service = new CBAG1010Service()

  /**
   * 画面要素描画後処理
   */
  mounted() {
    fixedContentNoLogin()
    this.init()
  }

  /**
   * 初期処理
   */
  private async init() {
    const cbaa1010ResponseModel = await this.cbag1010Service.callAPICBAA1010()
    if (cbaa1010ResponseModel.notPrncpSecrTypLst) {
      const response = cbaa1010ResponseModel.notPrncpSecrTypLst.map((x) => {
        if (x.feeTrustRewd) {
          const feeTrustRewd = CommonUtil.roundNumber(
            x?.feeTrustRewd,
            FormatConstants.ANNUAL_RATE_FIVE_DIGITS
          )
          x.feeTrustRewd =
            feeTrustRewd !== null ? feeTrustRewd.toFixed(5) : x.feeTrustRewd
        }

        return {
          ...x
        }
      })
      this.cbag1010ViewModel.notPrncpSecrTypLst = JSON.parse(
        JSON.stringify(response)
      )
    } else {
      this.cbag1010ViewModel.notPrncpSecrTypLst = []
    }

    if (cbaa1010ResponseModel.notPrncpSecrTypStpNewLst) {
      const response = cbaa1010ResponseModel.notPrncpSecrTypStpNewLst.map(
        (x) => {
          if (x.feeTrustRewd) {
            const feeTrustRewd = CommonUtil.roundNumber(
              x?.feeTrustRewd,
              FormatConstants.ANNUAL_RATE_FIVE_DIGITS
            )
            x.feeTrustRewd =
              feeTrustRewd !== null ? feeTrustRewd.toFixed(5) : x.feeTrustRewd
          }
          return {
            ...x
          }
        }
      )
      this.cbag1010ViewModel.notPrncpSecrTypStpNewLst = JSON.parse(
        JSON.stringify(response)
      )
    } else {
      this.cbag1010ViewModel.notPrncpSecrTypStpNewLst = []
    }

    if (cbaa1010ResponseModel.prncpSecrTypLst) {
      this.cbag1010ViewModel.prncpSecrTypLst =
        cbaa1010ResponseModel.prncpSecrTypLst
    } else {
      this.cbag1010ViewModel.prncpSecrTypLst = []
    }

    if (cbaa1010ResponseModel.prncpSecrTypStpNewLst) {
      this.cbag1010ViewModel.prncpSecrTypStpNewLst =
        cbaa1010ResponseModel.prncpSecrTypStpNewLst
    } else {
      this.cbag1010ViewModel.prncpSecrTypStpNewLst = []
    }

    this.cbag1010ViewModel.batchDispDiv = cbaa1010ResponseModel.batchDispDiv
  }

  /**
   * 元本確保型タブ切り替え
   * @param tab
   */
  private changeTab(tab) {
    this.cbag1010ViewModel.tabActive = tab
  }

  /**
   * 戻るリンク押下
   */
  private gotoCAAG1010() {
    this.$router.push({ name: 'caag1010' })
  }
}
